export { ScrollToElementDirective as default };

const ScrollToElementDirective = {
    updated(el, binding, vnode, prevVnode) {
    if (binding.value) {
        el.scrollIntoView({
            behavior: 'smooth',
            block: 'nearest',
            inline: 'start'
        })
    }
  },
}